/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react'
import useStyles from './styles'
import { TextareaAutosize } from '@mui/material'

interface Props {
  placeholder: string
  minRows: number
  id?: string
  name?: string
  value?: string
  error?: boolean
  helperText?: string
  onChangeHandler?: (
    e: React.ChangeEvent<any>
  ) =>
    | void
    | React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
    | React.SyntheticEvent
}
export default function MaxHeightTextarea({
  minRows,
  placeholder,
  id,
  name,
  value,
  helperText,
  onChangeHandler,
}: Props) {
  const { classes } = useStyles()

  return (
    <>
      <TextareaAutosize
        id={id || ''}
        name={name || ''}
        value={value}
        role={'textbox'}
        aria-labelledby={placeholder}
        minRows={minRows}
        aria-label="maximum height"
        placeholder={placeholder}
        onChange={onChangeHandler}
        className={classes.root}
      />
      <p className={classes.error}>{helperText}</p>
    </>
  )
}
